





















































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';

const cssPrefix = 'order-refund';

@Component({
  components: {
    ...UUIFComponent,
    SwTextarea,
  },
})
export default class OrderRefund extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop()
  showOrderRefund: boolean;
  @Prop()
  orderDetails : any;
  refund: {
    refundReason?: string;
    subStatus?: string;
    refundAmount?: string;
    totalAmount?: number;
    totalTaxAmount?: number;
  } = {
    subStatus: 'FULLREFUND',
    refundReason: '',
    refundAmount: '',
    totalAmount: 0,
    totalTaxAmount: 0,
  };
  refundExceedError: boolean = false;
  refundReasonError: boolean = false;
  refundAmountRequired: boolean = false;
  isInvalid: boolean = false;
  created() {
    console.warn(this.orderDetails);
    this.refund.totalAmount = this.orderDetails.totalPrice ? this.orderDetails.totalPrice : 0;
    this.refund.totalTaxAmount = this.orderDetails.totalTax ? this.orderDetails.totalTax : 0;
  }
  closeDialog() {
    this.$emit('closeDialog');
  }
  handleChange() {
    if (this.refund.subStatus === 'PARTIALREFUND') {
      this.refund.refundAmount = '';
    }
  }
  onEntertextAreaInput() {
    if (this.refundReasonError) this.refundReasonError = false;
  }
  voidOrder() {
    this.refundAmountRequired = false;
    this.refundReasonError = false;
    if (this.refund.refundReason === '') {
      this.refundReasonError = true;
    }
    if (this.refund.refundAmount === '' && this.refund.subStatus === 'PARTIALREFUND') {
      this.refundAmountRequired = true;
    }
    if (this.refund.subStatus === 'PARTIALREFUND') {
      if (!this.refundAmountRequired && Number(this.refund.refundAmount) <= Number(this.refund.totalAmount) && !this.isInvalid) {
        if (!this.refundReasonError) {
          const result = {
            eorderId: this.orderDetails.orderNo,
            voidComments: this.refund.refundReason,
            subStatus: this.refund.subStatus,
            refundAmount: this.refund.refundAmount,
          };
          console.warn(result);
          this.$emit('voidSuccess', result);
        }
      } else {
        this.refundExceedError = true;
      }
    }  else {
      if (!this.refundReasonError) {
        const result = {
          eorderId: this.orderDetails.orderNo,
          voidComments: this.refund.refundReason,
          subStatus: this.refund.subStatus,
        };
        this.$emit('voidSuccess', result);
        console.warn(result);
      }
    }
  }
  onEnterInput() {
    if (this.refundExceedError) this.refundExceedError = false;
    if (this.refundAmountRequired) this.refundAmountRequired = false;
    const pat =   /^\d+[.]*\d*$/;
    if (this.refund.refundAmount && this.refund.refundAmount.match(pat)) {
      this.isInvalid = false;
    } else {
      this.isInvalid = true;
    }
  }
}
